import { render, staticRenderFns } from "./updateExternalUserForm.vue?vue&type=template&id=b8204a58&scoped=true&"
import script from "./updateExternalUserForm.vue?vue&type=script&lang=js&"
export * from "./updateExternalUserForm.vue?vue&type=script&lang=js&"
import style0 from "./updateExternalUserForm.vue?vue&type=style&index=0&id=b8204a58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8204a58",
  null
  
)

export default component.exports